<template>
	<div>
		<CCard>
			<CCardHeader>Historique facturation des points de vente</CCardHeader>

			<CCardBody>
				<CRow>
					<CCol col="6">
						<div role="group" class="form-group">
							<label>Du</label>
							<div class="input-group">
								<input
									v-model="startDate"
									type="string"
									class="form-control"
									v-maska="'##/####'" />
								<div class="input-group-append">
									<span class="input-group-text">
										<CIcon name="cil-calendar" />
									</span>
								</div>
								<small class="form-text text-muted w-100"
									>Exemple: 12/2021 (mois/année)</small
								>
							</div>
						</div>
					</CCol>
					<CCol col="6">
						<div role="group" class="form-group">
							<label>Au</label>
							<div class="input-group">
								<input
									v-model="endDate"
									type="string"
									class="form-control"
									v-maska="'##/####'" />
								<div class="input-group-append">
									<span class="input-group-text">
										<CIcon name="cil-calendar" />
									</span>
								</div>
								<small class="form-text text-muted w-100"
									>Exemple: 12/2021 (mois/année)</small
								>
							</div>
						</div>
					</CCol>
				</CRow>

				<GDataTableRemote
					v-if="url"
					ref="mainTable"
					:remote-url="url"
					:fields="fields"
					:items-per-page="10"
					class="mt-4"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #commission="{ item }">
						<td>
							{{ $numeral(item.commission).format('0,0.00 $') }}
						</td>
					</template>

					<template #commissionSuppWeightAmount="{ item }">
						<td>
							{{ $numeral(item.commissionSuppWeightAmount).format('0,0.00 $') }}
						</td>
					</template>

					<template #amountDue="{ item }">
						<td>
							{{ $numeral(item.amountDue).format('0,0.00 $') }}
						</td>
					</template>

					<template #remainingDue="{ item }">
						<td>
							{{ $numeral(item.remainingDue).format('0,0.00 $') }}
						</td>
					</template>

					<template #cA="{ item }">
						<td>
							{{ $numeral(item.cA).format('0,0.00 $') }}
						</td>
					</template>

					<template #commissionHT="{ item }">
						<td>
							{{ $numeral(item.commissionHT).format('0,0.00 $') }}
						</td>
					</template>

					<template #pointOfSale.name="{ item }">
						<td>[{{ item.pointOfSale.reference }}] {{ item.pointOfSale.name }}</td>
					</template>

					<template #periodStartDate="{ item }">
						<td>
							du {{ $moment(item.periodStartDate).format('DD/MM/YYYY') }} au
							{{ $moment(item.periodEndDate).format('DD/MM/YYYY') }}
						</td>
					</template>

					<template #status="{ item }">
						<td>
							<CBadge :color="statusColor[item.status]">{{
								statusTranslation[item.status]
							}}</CBadge>
						</td>
					</template>

					<template #actions="{ item }">
						<td class="text-center" style="white-space: nowrap">
							<a class="text-center icon-space" href="#" @click="download(item)">
								<CIcon name="cil-print" />
							</a>
							<a class="text-center icon-space ml-3" href="#" @click="showPayments(item)">
								<CIcon name="cil-bank" />
							</a>
							<router-link
								class="text-center icon-space ml-3"
								:to="`/points-of-sale/history/credit-notes/${item.id}`">
								<CIcon name="cil-settings" />
							</router-link>
						</td>
					</template>
				</GDataTableRemote>
			</CCardBody>
		</CCard>

		<PaymentsHistoryModal ref="paymentsHistoryModal" v-on:refresh="refresh" />
		<div :class="loading ? 'gen_pdf_indicator active' : 'gen_pdf_indicator'">
			<p>
				Téléchargement en cours
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
			</p>
		</div>
	</div>
</template>

<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote.vue';
	import PaymentsHistoryModal from './payments-history-modal';
	export default {
		name: 'history',
		components: { PaymentsHistoryModal, GDataTableRemote },
		data() {
			return {
				loading: false,
				startDate: null,
				endDate: null,
				url: '/api/pos_invoices',
				fields: [
					{ key: 'id', label: 'N° Facture' },
					{ key: 'periodStartDate', label: 'Période facturé', filter: false, sorter: false },
					{ key: 'createdAt', label: 'Date création', type: 'datetime' },
					{ key: 'commission', label: 'Commission (€)' },
					{ key: 'commissionHT', label: 'Commission HT (€)' },
					{ key: 'commissionSuppWeightAmount', label: 'Commission Kg Supp (€)' },
					{ key: 'amountDue', label: 'Montant dû (€)' },
					{ key: 'remainingDue', label: 'Montant restant (€)' },
					{ key: 'cA', label: 'CA (€)' },
					{ key: 'pointOfSale.name', label: 'Revendeur' },
					{
						key: 'status',
						label: 'Status',
						type: 'select',
						filterSelectOptions: [
							{ value: 'pos_invoice.pending', label: 'En attente' },
							{ value: 'pos_invoice.paid', label: 'Payé' },
						],
					},
					{ key: 'actions', label: 'Action' },
				],
				statusTranslation: {
					'pos_invoice.pending': 'En attente',
					'pos_invoice.partially_paid': 'Partiel',
					'pos_invoice.paid': 'Payé',
				},
				statusColor: {
					'pos_invoice.pending': 'danger',
					'pos_invoice.partially_paid': 'warning',
					'pos_invoice.paid': 'success',
				},
			};
		},

		watch: {
			startDate(newVal) {
				if (newVal.length >= 7) {
					this.update();
				}
			},

			endDate(newVal) {
				if (newVal.length >= 7) {
					this.update();
				}
			},
		},

		methods: {
			refresh() {
				this.$refs.mainTable.refresh();
			},

			update() {
				let startDate = this.$moment('01/' + this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
				let params = new URLSearchParams();

				params.append('periodStartDate[after]', startDate);

				if (this.endDate) {
					const endDate = this.$moment('01/' + this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
					params.append('periodStartDate[before]', endDate);
				} else {
					let startDate = this.$moment('31/' + this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
					params.append('periodStartDate[before]', startDate);
				}

				this.url = `/api/pos_invoices?${params.toString()}`;
			},

			download(item) {
				this.loading = true;
				// download the file
				this.$axios
					.get(`/api/pos_invoices/pdf/${item.id}`, { responseType: 'blob' })
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
						});
					})
					.finally(() => {
						this.loading = false;
					});
			},

			showPayments(item) {
				this.$refs.paymentsHistoryModal.posInvoice = item;
				this.$refs.paymentsHistoryModal.showModal = true;
			},
		},
	};
</script>

<style>
	.gen_pdf_indicator {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px;
		border-radius: 5px;
		background-color: #321fdb;
		color: white;
		position: fixed;
		bottom: 15px;
		right: 15px;
		opacity: 0;
		transform: translateY(100%);
		transition: all 0.3s ease-in-out;
	}

	.gen_pdf_indicator.active {
		opacity: 1;
		transform: translateY(0);
	}

	.gen_pdf_indicator * {
		margin: 0;
	}

	.gen_pdf_indicator span {
		margin-left: 10px;
	}
</style>
